import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel'
import { Box, Tab } from '@mui/material';
import React from 'react'
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Base from '../../../Base/views/Base';
import MyTimeSheetGrid from './TimeSheet/MyTimeSheetGrid';
import MyTimeOff from './TimeOff/MyTimeOff';
import { getUserData } from '../../../Base/helper/baseFunctions';
import { GetEmployeeDashboardAction } from '../../../../../store/EmployeeDashboard/Action';
import MyAttendancePermission from './MyPermission/MyAttendancePermission';
import MyRegularization from './MyRegularization/MyRegularization';
import MyAttendanceLandingPage from './MyAttendance/MyAttendanceLandingPage';
import MyAttendanceHistory from './MyAttendance/MyAttendanceHistory';

const MyTimeSheetLandingPage = () => {
    const dispatch = useDispatch();
    const empData = getUserData();
    const [value, setValue] = useState('1');
    const [calendarValue, setCalendarValue] = useState();
    const handleChange = (event, newValue, calendarValue) => {
        setValue(newValue);
        setCalendarValue(calendarValue);
    };

    useEffect(() => {
        dispatch(GetEmployeeDashboardAction());
        //eslint-disable-next-line
    }, [])
    return (
        <Base>
            <Box sx={{ maxHeight: "calc(100vh - 70px)", overflowY: 'auto'}}>
                <TabContext value={value}>
                    <Box>
                        <TabList 
                            sx={{
                                minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                                '& .MuiTabs-indicator': {
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: "center !important",
                                },
                            }} 
                            onChange={handleChange} 
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                            >
                            <Tab label="Time Sheets" value="1" />
                            <Tab label="Time Off" value="2" />
                            <Tab label="My Attendance" value="3" />
                            <Tab label="My Permission" value="4" />
                            <Tab label="My Regularization" value="5" />
                        </TabList>
                    </Box>

                    <TabPanel value="1" sx={{ padding: "0px" }}>
                        <MyTimeSheetGrid />
                    </TabPanel>
                    <TabPanel value="2" sx={{ padding: "0px" }}>
                        <MyTimeOff calendarValue={calendarValue} />
                    </TabPanel>
                    <TabPanel value="3" sx={{ padding: "0px" }}>
                        {empData?.facerecognition_flow ? (
                            <MyAttendanceLandingPage faceRecogFlow={!!empData?.facerecognition_flow}/>
                        ) : (
                            <MyAttendanceHistory faceRecogFlow={!!empData?.facerecognition_flow}/>
                        )}
                    </TabPanel>
                        <TabPanel value="4" sx={{ padding: "0px" }}>
                        <MyAttendancePermission />
                    </TabPanel>
                    <TabPanel value="5" sx={{ padding: "0px" }}>
                        <MyRegularization />
                    </TabPanel>

                </TabContext>    
            </Box>
        </Base>
    )
}

export default MyTimeSheetLandingPage;